export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const advantages = [
    { icon: 'ri-search-eye-line', text: 'Предварительная диагностика и аудит отдела продаж' },
    { icon: 'ri-tools-fill', text: '80% практики на реальных кейсах компании' },
    { icon: 'ri-bar-chart-grouped-line', text: 'Рост конверсии и прибыли — измеримый результат' },
    { icon: 'ri-user-heart-line', text: 'Сопровождение внедрения после обучения' },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/e710e42b-e287-430c-bcda-0bcd98ae0d26_compressed_IMG_1156.webp"
          alt="Алексей Сивко — тренинг по продажам для сотрудников"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-28 md:pt-20 pb-10 md:pb-16">
        <div className="max-w-3xl">
          <div className="text-left">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-5 leading-tight">
              Тренинг по продажам для сотрудников
            </h1>
            <p className="text-base md:text-lg text-white/85 mb-8 leading-relaxed max-w-2xl">
              Не лекции и мотивационные речи. Системная работа: диагностика текущих показателей, практическое обучение на реальных кейсах и сопровождение внедрения изменений. Работаем с командами из Беларуси, России, Казахстана, Узбекистана и Израиля.
            </p>

            <div className="space-y-3 mb-10">
              {advantages.map((item, i) => (
                <div key={i} className="flex items-center gap-3 text-white/90">
                  <div className="w-8 h-8 bg-teal-600/80 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-sm text-white`}></i>
                  </div>
                  <span className="text-sm md:text-base">{item.text}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 mb-16 md:mb-0">
              <button
                onClick={() => scrollTo('contact')}
                className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center"
              >
                Получить программу
                <i className="ri-arrow-right-line"></i>
              </button>
              <button
                onClick={() => scrollTo('contact')}
                className="bg-white/15 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white/25 transition-all hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center border border-white/30"
              >
                Обсудить задачу
                <i className="ri-chat-1-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}